import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { cn } from '../../utils/cn';
const FormField = React.forwardRef(({ className, ...props }, ref) => {
    return (_jsx("div", { ref: ref, className: cn('space-y-2', className), ...props }));
});
FormField.displayName = 'FormField';
export { FormField };
